import type { SessionResponseDto } from "@madamuh/domain";

export function hasTenantMatchedSession(
  tenantSlug: string,
  session: SessionResponseDto | null | undefined
): session is SessionResponseDto {
  return Boolean(session && session.tenant.tenantSlug === tenantSlug);
}

export function canReuseExistingTenantSessionForEntry(
  tenantSlug: string,
  session: SessionResponseDto | null | undefined
): boolean {
  return hasTenantMatchedSession(tenantSlug, session);
}

export function canShortCircuitOwnerOnboardingToOperatorRoute(
  tenantSlug: string,
  session: SessionResponseDto | null | undefined,
  ownerOnboardingToken: string
): session is SessionResponseDto & { member: NonNullable<SessionResponseDto["member"]> } {
  if (!ownerOnboardingToken.trim() || !hasTenantMatchedSession(tenantSlug, session) || !session.member) {
    return false;
  }

  return session.member.roles.includes("teacher") || session.member.roles.includes("admin");
}
